"use client";

import _createForOfIteratorHelper from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { setProperty } from "./K2ZF5NU7.js"; // src/dialog/utils/walk-tree-outside.ts

import { contains, getDocument } from "@ariakit/core/utils/dom";
import { chain } from "@ariakit/core/utils/misc";
var ignoreTags = ["SCRIPT", "STYLE"];

function getSnapshotPropertyName(id) {
  return "__ariakit-dialog-snapshot-".concat(id);
}

function inSnapshot(id, element) {
  var doc = getDocument(element);
  var propertyName = getSnapshotPropertyName(id);
  if (!doc.body[propertyName]) return true;

  do {
    if (element === doc.body) return false;
    if (element[propertyName]) return true;
    if (!element.parentElement) return false;
    element = element.parentElement;
  } while (true);
}

function isValidElement(id, element, ignoredElements) {
  if (ignoreTags.includes(element.tagName)) return false;
  if (!inSnapshot(id, element)) return false;
  return !ignoredElements.some(function (enabledElement) {
    return enabledElement && contains(element, enabledElement);
  });
}

function walkTreeOutside(id, elements, callback, ancestorCallback) {
  var _iterator = _createForOfIteratorHelper(elements),
      _step;

  try {
    var _loop = function _loop() {
      var element = _step.value;
      if (!(element == null ? void 0 : element.isConnected)) return "continue";
      var hasAncestorAlready = elements.some(function (maybeAncestor) {
        if (!maybeAncestor) return false;
        if (maybeAncestor === element) return false;
        return maybeAncestor.contains(element);
      });
      var doc = getDocument(element);
      var originalElement = element;

      while (element.parentElement && element !== doc.body) {
        ancestorCallback == null ? void 0 : ancestorCallback(element.parentElement, originalElement);

        if (!hasAncestorAlready) {
          var _iterator2 = _createForOfIteratorHelper(element.parentElement.children),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var child = _step2.value;

              if (isValidElement(id, child, elements)) {
                callback(child, originalElement);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }

        element = element.parentElement;
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function createWalkTreeSnapshot(id, elements) {
  var _getDocument = getDocument(elements[0]),
      body = _getDocument.body;

  var cleanups = [];

  var markElement = function markElement(element) {
    cleanups.push(setProperty(element, getSnapshotPropertyName(id), true));
  };

  walkTreeOutside(id, elements, markElement);
  return chain(setProperty(body, getSnapshotPropertyName(id), true), function () {
    var _iterator3 = _createForOfIteratorHelper(cleanups),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var cleanup = _step3.value;
        cleanup();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  });
}

export { isValidElement, walkTreeOutside, createWalkTreeSnapshot };